'use client';

import {
  PropsWithChildren,
  useState,
  createContext,
  Dispatch,
  SetStateAction,
  useEffect,
} from 'react';
import { useSearchParams } from 'next/navigation';

import { createFiltersStateFromParams } from '../../utils/filters/createFiltersStateFromParams';
import { FilterConfigs, FiltersState } from '../../types/filters';

type FiltersContextValue =
  | [
      FiltersState,
      Dispatch<SetStateAction<FiltersState>>,
      Dispatch<SetStateAction<FiltersState | null>>
    ]
  | [];

export const FiltersContext = createContext<FiltersContextValue>([]);

export const FiltersProvider = ({
  children,
  configs,
}: PropsWithChildren<{
  initialValue?: FiltersState;
  configs: FilterConfigs;
}>) => {
  const searchParams = useSearchParams();

  const [state, setState] = useState<FiltersState>({});

  const [mediatorState, setMediatorState] = useState<FiltersState | null>(null);

  useEffect(() => {
    const filtersState = createFiltersStateFromParams(configs, searchParams);

    setState(filtersState);
  }, [searchParams, configs]);

  const stateForReturn = mediatorState ?? state;

  return (
    <FiltersContext.Provider
      value={[stateForReturn, setState, setMediatorState]}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export default FiltersProvider;
